module.exports = __webpack_public_path__ + "media/images/google-plus-8ef5e6eb19786f3507a0b48ff0b0dd65.svg";